<template lang="pug">
    div
        div(:id="playerId" class="video")
</template>

<script>
    import VueTypes from 'vue-types';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            playerId: VueTypes.string.def('videoPlayer'),
            fullScreen: VueTypes.bool.def(false),
            options: VueTypes.object.def({}),
            onPlayerReady: VueTypes.func.def(() => {}),
            onBeforeDestroyPlayer: VueTypes.func.def(() => {})
        },
        data() {
            return {
                player: null,
                playerElement: null,
                isScriptLoading: false
            };
        },
        mounted() {
            // If another component is already loading the script
            this.$root.$on('loadingScript', () => {
                this.isScriptLoading = true;
            });

            // If script is not loading yet
            if (!this.isScriptLoading) {
                this.useScript();
            }
        },
        beforeDestroy() {
            if (this.player) {
                this.onBeforeDestroyPlayer(this.player);
                this.player.api('stop');
            }

            if (this.playerElement) {
                this.playerElement.removeEventListener('init', () =>
                    this.onPlayerReady(this.player)
                );
            }

            if (this.fullScreen && this.playerElement) {
                this.playerElement.removeEventListener('play', () =>
                    this.player.api('fullscreen')
                );
            }
        },
        computed: {
            ...mapGetters('auth', ['isAdmin'])
        },

        methods: {
            /**
             * Load script with player
             *
             * @returns {Promise<unknown>}
             */
            loadScript() {
                let self = this;
                return new Promise(resolve => {
                    // If script is already loading with another component
                    if (self.isScriptLoading) {
                        // Resolve when the other component has loaded the script
                        this.$root.$on('scriptLoaded', resolve);
                        return;
                    }

                    const playerFilePath = this.isAdmin
                        ? '/player-with-speed-setting-admin.js'
                        : '/test-sizing-video.js';

                    // Create script element
                    let script = document.createElement('script');
                    script.setAttribute('src', playerFilePath);
                    script.async = true;

                    // Load script
                    this.$root.$emit('loadingScript');

                    script.onload = () => {
                        // Emit to global event bus to inform other components we are already loading the script
                        this.$root.$emit('scriptLoaded');
                        resolve();
                    };

                    // Add script to head section
                    document.head.appendChild(script);
                });
            },

            /**
             * Use player script and run player
             *
             * @returns {Promise<void>}
             */
            async useScript() {
                try {
                    // Load script
                    await this.loadScript();

                    // Set player options
                    var options = {
                        id: this.playerId,
                        ...this.options
                    };
                    // Create playerJS
                    this.player = new Playerjs(options);

                    this.playerElement = document.getElementById(this.playerId);

                    if (this.playerElement) {
                        // Init player
                        this.playerElement.addEventListener('init', () =>
                            this.onPlayerReady(this.player)
                        );

                        if (this.fullScreen) {
                            this.playerElement.addEventListener('play', () =>
                                this.player.api('fullscreen')
                            );
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .video
        width: 100%
        height: 100%
</style>
